export enum ActivityType {

    EBookNotAllowed = "EBookNotAllowed",
}
